var postfixContainerPreset = {
  width: {
    xs: '56px',
    s: '56px',
    m: '56px',
    l: '80px'
  },
  height: {
    xs: '48px',
    s: '48px',
    m: '56px',
    l: '80px'
  }
};

export { postfixContainerPreset };
